import { nullish, object, string, optional, type InferInput, fallback } from 'valibot';

export type DcpTranslations = InferInput<typeof dcpTranslations>;
export type DcpFacetKeys = keyof DcpTranslations['dcp']['search']['facet'];
export type DcpUnitKeys = keyof DcpTranslations['dcp']['unit'];

export const dcpTranslations = object({
  dcp: object({
    campaignTags: optional(
      object({
        all_other: optional(string()),
      }),
    ),
    srp: object({
      footnotes: optional(
        object({
          powerHybrid: optional(string()),
        }),
      ),
    }),
    unit: object({
      HP: string(),
      KG: nullish(string()),
      KM: nullish(string()),
      KW: string(),
    }),
    search: object({
      facet: object({
        ALL_WHEEL_PERMANENT: fallback(string(), 'dcp.search.facet.ALL_WHEEL_PERMANENT'),
        AUTOMATIC: fallback(string(), 'dcp.search.facet.AUTOMATIC'),
        badges: fallback(string(), 'dcp.search.facet.badges'),
        bodyType: fallback(string(), 'dcp.search.facet.bodyType'),
        CABRIO: fallback(string(), 'dcp.search.facet.CABRIO'),
        CHASSIS: fallback(string(), 'dcp.search.facet.CHASSIS'),
        CHASSIS_CREW_CAB: fallback(string(), 'dcp.search.facet.CHASSIS_CREW_CAB'),
        combinedPower: fallback(string(), 'dcp.search.facet.combinedPower'),
        COUPE: fallback(string(), 'dcp.search.facet.COUPE'),
        DIESEL: fallback(string(), 'Diesel'),
        DIESEL_ELECTRIC_PLUGIN_HYBRID: fallback(string(), 'dcp.search.facet.DIESEL_ELECTRIC_PLUGIN_HYBRID'),
        driveType: fallback(string(), 'dcp.search.facet.driveType'),
        ELECTRIC: fallback(string(), 'Electric'),
        FRONT_WHEEL: fallback(string(), 'dcp.search.facet.FRONT_WHEEL'),
        fuel_type: fallback(string(), 'dcp.search.facet.fuel_type'),
        gearBox: fallback(string(), 'dcp.search.facet.gearBox'),
        HATCHBACK: fallback(string(), 'dcp.search.facet.HATCHBACK'),
        LIMOUSINE: fallback(string(), 'dcp.search.facet.LIMOUSINE'),
        lines: fallback(string(), 'dcp.search.facet.lines'),
        loadingSpaceHeight: fallback(string(), 'dcp.search.facet.loadingSpaceHeight'),
        loadingSpaceLength: fallback(string(), 'dcp.search.facet.loadingSpaceLength'),
        loadingSpaceVolume: fallback(string(), 'dcp.search.facet.loadingSpaceVolume'),
        loadingSpaceWidth: fallback(string(), 'dcp.search.facet.loadingSpaceWidth'),
        MARCO_POLO: fallback(string(), 'dcp.search.facet.MARCO_POLO'),
        maxLoad: fallback(string(), 'dcp.search.facet.maxLoad'),
        maxWeight: fallback(string(), 'dcp.search.facet.maxWeight'),
        MIXTO: fallback(string(), 'dcp.search.facet.MIXTO'),
        model: fallback(string(), 'dcp.search.facet.model'),
        numberOfSeats: fallback(string(), 'dcp.search.facet.numberOfSeats'),
        packages: fallback(string(), 'dcp.search.facet.packages'),
        PETROL: fallback(string(), 'Petrol'),
        PETROL_ELECTRIC_PLUGIN_HYBRID: fallback(string(), 'dcp.search.facet.PETROL_ELECTRIC_PLUGIN_HYBRID'),
        priceValue: fallback(string(), 'dcp.search.facet.priceValue'),
        REAR_WHEEL: fallback(string(), 'dcp.search.facet.REAR_WHEEL'),
      }),
    }),
    products: object({
      open: string(),
    }),
  }),
});
